import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  rootStyle: {
    border: 'solid 1px #D3D5DB',
    margin: '1.5rem 0 1.5rem 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1.5rem',
    padding: '0.5rem',
    borderRadius: '0.5rem',
    backgroundColor: '#FFFFFF'
  },
  textStyle:{
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    lineHeight: '20px !important',
    color: '#1E1F21 !important'
  },
  buttonStyle:{
    padding: '6px 8px !important',
    gap: '10px !important',
    background: '#0C20B5 !important',
    borderRadius: '4px !important',
    color: '#FFFFFF !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '12px !important',
    lineHeight: '20px !important',

  }
}));

export default useStyles;